import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  TableTitleData, TableTitleRow, TableTitleSelection
} from '@design-system/components/molecules/table-title/entities/table-title.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';

@Component({
  selector: 'app-ds-table-title',
  templateUrl: './table-title.component.html',
  styleUrls: ['./table-title.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
    DividerDsComponent,
  ]
})
export class TableTitleDsComponent {

  @Input() data: TableTitleData;

  @Output() selected: EventEmitter<TableTitleSelection> = new EventEmitter<TableTitleSelection>();

  public readonly rowActionIcon = Icon.ChevronRight;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor() { }

  get rowsByColumns(): TableTitleRow[][] {
    if (this.data?.Columns?.length) {
      const response = [];
      this.data?.Columns.forEach((column, col) => {
        column?.Rows.forEach((rows, row) => {
          if (response?.[row]) {
            response[row][col] = rows;
          } else {
            response[row] = [];
            response[row][col] = rows;
          }
        });
      });
      return response;
    } else {
      return [];
    }
  }

  public trackById(index: number): number {
    return index;
  }

  public emit(rowViewId: number, colViewId: number): void {
    if (this.data?.EmitValue) {
      this.selected.emit({ Row: rowViewId, Column: colViewId });
    }
  }

}
